module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-star-empty-683fff1e72398bea96bfe82ec3f9fa17.png";